import React, { useState } from "react";
// import AppBar from "@material-ui/core/AppBar";

import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";
// import LanguageSwitcher from "../../LanguageSwitcher";
// import Hidden from "@material-ui/core/Hidden";
import HorizontalNav from "../../Navigation/HorizontalNavV2";
import Box from "@material-ui/core/Box";
import useStyles from "./AppHeader.style";
// import SearchBar from "../../SearchBar";
// import NotificationBar from "./NotificationBar";
// import clsx from "clsx";
import HeaderMessages from "../../HeaderMessages";
// import Notifications from "../../Notifications";
// import MoreIcon from "@material-ui/icons/MoreVert";
import HorUserInfo from "../HorUserInfo";
import AppLogo from "../../../../shared/components/AppLogo";
import { toggleNavCollapsed, useLayoutActionsContext } from "../LayoutContextProvider";
import { AppBar, useMediaQuery, useTheme } from "@mui/material";
import { AppLngSwitcherV2 } from "@crema/core/LanguageSwitcher/LanguageSwitcherV2";
// import UserInfo from "shared/components/UserInfo";

interface AppHeaderProps {}

const AppHeader: React.FC<AppHeaderProps> = () => {
  const classes = useStyles();
  const [
    mobileMoreAnchorEl,
    setMobileMoreAnchorEl,
  ] = useState<null | HTMLElement>(null);

  const theme = useTheme();
  const widest = useMediaQuery(theme.breakpoints.up('lg'));

  const dispatch = useLayoutActionsContext()!;

  function handleMobileMenuClose() {
    setMobileMoreAnchorEl(null);
  }

  // function handleMobileMenuOpen(event: React.MouseEvent<HTMLElement>) {
  //   setMobileMoreAnchorEl(event.currentTarget);
  // }

  const mobileMenuId = 'primary-search-account-menu-mobile';
  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      id={mobileMenuId}
      keepMounted
      // anchorOrigin={{vertical: 'top', horizontal: 'right'}}
      // transformOrigin={{vertical: 'top', horizontal: 'right'}}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={Boolean(mobileMoreAnchorEl)}
      onClose={handleMobileMenuClose}>
      <MenuItem className={classes.menuItemRoot}>
        <HeaderMessages />
      </MenuItem>
      {/* <MenuItem className={classes.menuItemRoot}>
        <Notifications />
      </MenuItem> */}
      {/* <LanguageSwitcher /> */}
      <AppLngSwitcherV2 />
    </Menu>
  );

  return (
    <>
      <AppBar position='relative' sx={{boxShadow: 0, borderBottom: '1px solid #c4c4c4'}}>
        {/* <NotificationBar /> */}
        <Toolbar className={classes.headerMain}>
          <Box className={classes.headerContainer}>
            <Box className={classes.headerMainFlex}>
              {/* <Hidden lgUp>
                <IconButton
                  edge='start'
                  className={classes.menuButton}
                  // color='inherit'
                  aria-label='open drawer'
                  onClick={() => dispatch(toggleNavCollapsed())}>
                  <MenuIcon className={classes.menuIconRoot} />
                </IconButton>
              </Hidden> */}
              {
                !widest &&
                <IconButton
                  edge='start'
                  className={classes.menuButton}
                  // color='inherit'
                  aria-label='open drawer'
                  onClick={() => dispatch(toggleNavCollapsed())}>
                  <MenuIcon className={classes.menuIconRoot} />
                </IconButton>
              }

              <Box flexShrink={0}>
                <AppLogo />
              </Box>
              
              {
                widest &&
                // <Box className={classes.headerNav}>
                //   <Box className={classes.headerContainer}>
                //     <HorizontalNav />
                //   </Box>
                // </Box>
                <HorizontalNav  />
              }

              <Box className={classes.grow} />
              {/* <SearchBar /> */}
              {/* <Box className={clsx(classes.sectionDesktop)}>
                <LanguageSwitcher />
                <HeaderMessages />
                <Notifications />
              </Box>

              <Box ml={1} className={classes.sectionMobile}>
                <IconButton
                  aria-label='show more'
                  aria-controls={mobileMenuId}
                  aria-haspopup='true'
                  onClick={handleMobileMenuOpen}
                  // color='inherit'
                >
                  <MoreIcon />
                </IconButton>
              </Box> */}

              <AppLngSwitcherV2 iconOnly />

              <HorUserInfo bgType='white' />
              {/* <UserInfo /> */}
            </Box>
          </Box>
        </Toolbar>
        {/* <Hidden mdDown>
          <Box className={classes.headerNav}>
            <Box className={classes.headerContainer}>
              <HorizontalNav />
            </Box>
          </Box>
        </Hidden> */}
        
      </AppBar>
      {renderMobileMenu}
    </>
  );
};
export default AppHeader;
